export const DAILY = 'daily';
export const QUARTERLY = 'quarterly';
export const MONTHLY = 'monthly';
export const YEARLY = 'yearly';

export const GROUP_ROLE = 'group';
export const INDIVIDUAL_ROLE = 'individual';
export const POLICY_ROLE = 'policy';
export const INDIVIDUAL_POLICY_ROLE = 'individual_policy';
export const TEAM_POLICY_ROLE = 'team_policy_role';
export const SUMMARY = 'summary';
export const EMPTY_SUMMARY = 'empty_summary';
export const MAX_HIER_LVL = 11;

export const AGT_PROFILE_CODE = 'AGT';

export const SUBMITTED_TYPE = 'submitted';
export const PENDING_TYPE = 'pending';
export const NEW_ISSUED_TYPE = 'new_settle';
export const NET_ISSUED_TYPE = 'net_settle';
export const CANCEL_TYPE = 'not_taken_and_reject';

export const LOADING = 'loading';
export const FILTER_DATE_TIME = 'filter_date_time';
export const CLICK_BREADCRUMB = 'click_breadcrumb';
export const CLICK_SUMMARY = 'click_summary';
export const CLICK_TAB = 'click_tab';
export const CLICK_NAME_ON_TABLE = 'click_name_on_table';

export const TABLE_REPORT = 'table';
export const PIE_CHART_REPORT = 'pie_chart';
export const TEAM_TEAM_TABLE_REPORT = 'team_team_table';
export const IND_TABLE_REPORT = 'ind_table';
export const IND_POLICY_TABLE_REPORT = 'ind_policy_table';
export const TEAM_POLICY_TABLE_REPORT = 'team_policy_table';

export const SUBMITTED_SUMMARY = 'submitted_summary';
export const PENDING_SUMMARY = 'pending_summary';
export const NEW_ISSUED_SUMMARY = 'new_settle_summary';
export const NET_ISSUED_SUMMARY = 'net_settle_summary';
export const CANCEL_SUMMARY = 'not_taken_and_reject_summary';

export const SUBMITTED_SUMMARY_TEAM = 'submitted_summary_team';
export const SUBMITTED_SUMMARY_IND = 'submitted_summary_ind';

export const SUBMITTED_PIE_CHART_TEAM = 'submitted_pie_chart_team';
export const PENDING_PIE_CHART_TEAM = 'pending_pie_chart_team';
export const NEW_ISSUED_PIE_CHART_TEAM = 'new_settle_pie_chart_team';
export const NET_ISSUED_PIE_CHART_TEAM = 'net_settle_pie_chart_team';
export const CANCEL_PIE_CHART_TEAM = 'not_taken_and_reject_pie_chart_team';

export const SUBMITTED_PIE_CHART_IND = 'submitted_pie_chart_ind';
export const PENDING_PIE_CHART_IND = 'pending_pie_chart_ind';
export const NEW_ISSUED_PIE_CHART_IND = 'new_settle_pie_chart_ind';
export const NET_ISSUED_PIE_CHART_IND = 'net_settle_pie_chart_ind';
export const CANCEL_PIE_CHART_IND = 'not_taken_and_reject_pie_chart_ind';

export const SUBMITTED_TEAM_TEAM_TABLE = 'submitted_team_team_table';
export const PENDING_TEAM_TEAM_TABLE = 'pending_team_team_table';
export const NEW_ISSUED_TEAM_TEAM_TABLE = 'new_settle_team_team_table';
export const NET_ISSUED_TEAM_TEAM_TABLE = 'net_settle_team_team_table';
export const CANCEL_TEAM_TEAM_TABLE = 'not_taken_and_reject_team_team_table';

export const SUBMITTED_IND_TABLE = 'submitted_ind_table';
export const PENDING_IND_TABLE = 'pending_ind_table';
export const NEW_ISSUED_IND_TABLE = 'new_settle_ind_table';
export const NET_ISSUED_IND_TABLE = 'net_settle_ind_table';
export const CANCEL_IND_TABLE = 'not_taken_and_reject_ind_table';

export const SUBMITTED_POLICY_IND_TABLE = 'submitted_policy_ind_table';
export const PENDING_POLICY_IND_TABLE = 'pending_policy_ind_table';
export const NEW_ISSUED_POLICY_IND_TABLE = 'new_settle_policy_ind_table';
export const NET_ISSUED_POLICY_IND_TABLE = 'net_settle_policy_ind_table';
export const CANCEL_POLICY_IND_TABLE = 'not_taken_and_reject_policy_ind_table';

export const SUBMITTED_POLICY_TEAM_TABLE = 'submitted_policy_team_table';
export const PENDING_POLICY_TEAM_TABLE = 'pending_policy_team_table';
export const NEW_ISSUED_POLICY_TEAM_TABLE = 'new_settle_policy_team_table';
export const NET_ISSUED_POLICY_TEAM_TABLE = 'net_settle_policy_team_table';
export const CANCEL_POLICY_TEAM_TABLE =
  'not_taken_and_reject_policy_team_table';

export const SUMMARY_TYPE_MAP = {
  submitted_summary_team_pie_chart: SUBMITTED_PIE_CHART_TEAM,
  pending_summary_team_pie_chart: PENDING_PIE_CHART_TEAM,
  new_settle_summary_team_pie_chart: NEW_ISSUED_PIE_CHART_TEAM,
  net_settle_summary_team_pie_chart: NET_ISSUED_PIE_CHART_TEAM,
  not_taken_and_reject_summary_team_pie_chart: CANCEL_PIE_CHART_TEAM,

  submitted_summary_ind_pie_chart: SUBMITTED_PIE_CHART_IND,
  pending_summary_ind_pie_chart: PENDING_PIE_CHART_IND,
  new_settle_summary_ind_pie_chart: NEW_ISSUED_PIE_CHART_IND,
  net_settle_summary_ind_pie_chart: NET_ISSUED_PIE_CHART_IND,
  not_taken_and_reject_summary_ind_pie_chart: CANCEL_PIE_CHART_IND,

  submitted_summary_team_team_team_table: SUBMITTED_TEAM_TEAM_TABLE,
  pending_summary_team_team_team_table: PENDING_TEAM_TEAM_TABLE,
  new_settle_summary_team_team_team_table: NEW_ISSUED_TEAM_TEAM_TABLE,
  net_settle_summary_team_team_team_table: NET_ISSUED_TEAM_TEAM_TABLE,
  not_taken_and_reject_summary_team_team_team_table: CANCEL_TEAM_TEAM_TABLE,

  submitted_summary_team_ind_table: SUBMITTED_IND_TABLE,
  pending_summary_team_ind_table: PENDING_IND_TABLE,
  new_settle_summary_team_ind_table: NEW_ISSUED_IND_TABLE,
  net_settle_summary_team_ind_table: NET_ISSUED_IND_TABLE,
  not_taken_and_reject_summary_team_ind_table: CANCEL_IND_TABLE,

  submitted_summary_ind_ind_table: SUBMITTED_IND_TABLE,
  pending_summary_ind_ind_table: PENDING_IND_TABLE,
  new_settle_summary_ind_ind_table: NEW_ISSUED_IND_TABLE,
  net_settle_summary_ind_ind_table: NET_ISSUED_IND_TABLE,
  not_taken_and_reject_summary_ind_ind_table: CANCEL_IND_TABLE,

  submitted_summary_ind_team_team_table: EMPTY_SUMMARY,
  pending_summary_ind_team_team_table: EMPTY_SUMMARY,
  new_issued_summary_ind_team_team_table: EMPTY_SUMMARY,
  net_issued_summary_ind_team_team_table: EMPTY_SUMMARY,
  not_taken_and_reject_summary_ind_team_team_table: EMPTY_SUMMARY,

  submitted_summary_team_empty_summary: EMPTY_SUMMARY,
  pending_summary_team_empty_summary: EMPTY_SUMMARY,
  new_settle_summary_team_empty_summary: EMPTY_SUMMARY,
  net_settle_summary_team_empty_summary: EMPTY_SUMMARY,
  cancel_summary_team_empty_summary: EMPTY_SUMMARY,

  submitted_summary_ind_empty_summary: EMPTY_SUMMARY,
  pending_summary_ind_empty_summary: EMPTY_SUMMARY,
  new_settle_summary_ind_empty_summary: EMPTY_SUMMARY,
  net_settle_summary_ind_empty_summary: EMPTY_SUMMARY,
  cancel_summary_ind_empty_summary: EMPTY_SUMMARY,

  submitted_summary_ind_ind_policy_table: SUBMITTED_POLICY_IND_TABLE,
  pending_summary_ind_ind_policy_table: PENDING_POLICY_IND_TABLE,
  new_settle_summary_ind_ind_policy_table: NEW_ISSUED_POLICY_IND_TABLE,
  net_settle_summary_ind_ind_policy_table: NET_ISSUED_POLICY_IND_TABLE,
  not_taken_and_reject_summary_ind_ind_policy_table: CANCEL_POLICY_IND_TABLE,

  submitted_summary_team_team_policy_table: SUBMITTED_POLICY_TEAM_TABLE,
  pending_summary_team_team_policy_table: PENDING_POLICY_TEAM_TABLE,
  new_settle_summary_team_team_policy_table: NEW_ISSUED_POLICY_TEAM_TABLE,
  net_settle_summary_team_team_policy_table: NET_ISSUED_POLICY_TEAM_TABLE,
  not_taken_and_reject_summary_team_team_policy_table: CANCEL_POLICY_TEAM_TABLE,

  submitted_summary_team_ind_policy_table: SUBMITTED_IND_TABLE,
  pending_summary_team_ind_policy_table: PENDING_IND_TABLE,
  new_settle_summary_team_ind_policy_table: NEW_ISSUED_IND_TABLE,
  net_settle_summary_team_ind_policy_table: NET_ISSUED_IND_TABLE,
  not_taken_and_reject_summary_team_ind_policy_table: CANCEL_IND_TABLE,
};

export const POLICY_BTN_STYLED = {
  padding: '0.5rem',
  width: '9rem',
  '@media (max-width: 475px)': {
    marginLeft: '0',
    marginRight: '1rem',
    marginTop: '1rem',
  },
};

export const POLICY_HEADER_STYLED = {
  height: '22.5rem',
  '@media (max-width: 475px)': {
    overflow: 'overlay',
  },
};

export const defaultDoughnutChart = {
  labels: ['', ''],
  datasets: [
    {
      data: [0, -1],
      backgroundColor: ['#65A8A8FF', '#E1E1DFFF'],
      hoverBackgroundColor: ['#FEBE10FF', '#FEBE10FF'],
      hoverBorderColor: ['#E0DCD1', '#E0DCD1'],
    },
  ],
};

export const DUE_INSURANCE_FEE_PERCENTAGE_TITLE =
  '(Phí BH đã thu / Tổng phí BH phải thu) * 100';

export const dateTypeConfig = {
  primaryId: 'dateTypeId',
  primaryName: 'dateTypeName',
};

export const datetimeConfig = {
  primaryId: 'datetimeId',
  primaryName: 'datetimeName',
};
export const defaultProfile = {
  order: 1,
  id: 'ACT1',
  code: '',
  name: 'My Name',
  shortName: 'My Name',
  role: GROUP_ROLE, // GROUP_ROLE
};
export const tabs = [
  {
    id: GROUP_ROLE,
    name: 'Nhóm',
  },
  {
    id: INDIVIDUAL_ROLE,
    name: 'Cá nhân',
  },
  {
    id: TEAM_POLICY_ROLE,
    name: 'Danh sách HĐ theo nhóm',
  },
];
export const flairTabs = [
  {
    id: GROUP_ROLE,
    name: 'Nhóm',
  },
  {
    id: INDIVIDUAL_ROLE,
    name: 'Cá nhân',
  },
  {
    id: TEAM_POLICY_ROLE,
    name: 'Danh sách HĐ theo nhóm',
  },
];
export const dateTypeItem = [
  {
    dateTypeId: DAILY,
    dateTypeName: 'Ngày',
  },
  {
    dateTypeId: MONTHLY,
    dateTypeName: 'Tháng',
  },
  {
    dateTypeId: QUARTERLY,
    dateTypeName: 'Quý',
  },
  {
    dateTypeId: YEARLY,
    dateTypeName: 'Năm',
  },
];

export const sortByFieldMap = {
  afyp: 'afyp',
};

export const policySortByFieldMap = {
  submittedDate: 'submitted_dt',
  appReceivedDate: 'app_recv_dt',
  issuedDate: 'issued_dt',
  customerName: 'cli_nm',
  servicingAgentName: 'serv_agt_nm',
  servicingAgentBranch: 'serv_agt_br',
  policyBranch: 'policy_branch',
  polId: 'pol_id',
  appNumber: 'app_number',
  mainProduct: 'main_product_cd',
  billModeCode: 'pol_bill_mode_cd',
  sharePercentage: 'share_percentage',
  policyStatusCode: 'pol_stat_cd',
  join1Up: 'join_one_up',
  afyp: 'afyp',
  ip: 'ip',
  fyp: 'fyp',
  '10%topup': 'topup10Percent',
  'net10%topup': 'netTopup10Percent',
  submittedAmountWithSettledDate: 'sbmt_iss_amt',
  submittedAmountWithPendingStatus: 'sbmt_pend_amt',
  submittedAmountWithReject: 'sbmt_canc_amt',
  submittedAmountWithNotSubmittedNBT: 'sbmt_wat_amt',
};

export const doughnutChartOptions = {
  cutout: '60%',
  plugins: {
    legend: {
      display: true,
      responsive: true,
      position: 'bottom',
      align: 'center',
    },
    datalabels: {
      formatter: (value, ctx) => {
        let sum = 0;
        const dataArr = ctx.chart.data.datasets[0].data;
        dataArr.map((data) => {
          return (sum += data);
        });
        if (value === 0 || sum === 0) return null;
        return ((value * 100) / sum).toFixed(2) + '%';
      },
      color: '#9a9a9a',
      font: {
        weight: 'bolder',
        size: 13,
      },
    },
  },
};

export const PolicyBillModeMap = {
  12: 'Năm',
  6: 'Nửa Năm',
  3: 'Quý',
  1: 'Tháng',
};

export const PolicySttMap = {
  U: 'Yêu cầu GQQLBH quyền lợi tử vong',
  V: 'Yêu cầu GQQLBH quyền lợi bệnh hiểm nghèo',
  1: 'Đang có hiệu lực',
  2: 'Miễn đóng phí trong trường hợp người đóng phí tử vong',
  3: 'HĐ đã hoàn tất đóng phí',
  4: 'HĐ đã hoàn tất đóng phí',
  A: 'Hủy trong 21 ngày cân nhắc',
  B: 'Mất hiệu lực',
  C: 'Sắp phát hành',
  D: 'Tử vong',
  E: 'Chấm dứt hợp đồng',
  F: 'Hoàn tất chi trả',
  H: 'Đáo hạn',
  M: 'Chuyển phí cho HĐ khác',
  PCCC: 'Đang xử lý',
  PCCU: 'Đang xử lý',
  PCRC: 'Đang xử lý',
  PCRU: 'Đang xử lý',
  PECC: 'Đang xử lý',
  PECU: 'Đang xử lý',
  PERC: 'Đang xử lý',
  PERU: 'Đang xử lý',
  R: 'Từ chối',
  T: 'Chuyển qua hồ sơ khác',
  W: 'N/A',
  X: 'N/A',
  K: 'Chuyển tài khoản',
  S: 'Tạm dừng đóng phí',
  6: 'Quyền lợi Thương tật toàn bộ và vĩnh viễn đã được chi trả. Hợp đồng vẫn được giữ lại để khách hàng được nhận các quyền lợi học vấn',
  G: 'Quyền lợi Thương tật toàn bộ và vĩnh viễn đã được chi trả. Hợp động kết thúc (chấm dứt hiệu lực)',
  5: 'Quyền lợi Tử vong đã được chi trả. Hợp đồng vẫn được giữ lại để khách hàng được nhận các quyền lợi học vấn',
  R1: 'Đang xử lý',
  R2: 'Đang xử lý',
  R3: 'Đang xử lý',
};

export const polSttCodeConfig = {
  primaryId: 'polSttCodeId',
  primaryName: 'polSttCodeName',
};

export const polSttCodeItems = [
  {
    polSttCodeId: '1',
    polSttCodeName: PolicySttMap['1'],
  },
  {
    polSttCodeId: '2',
    polSttCodeName: PolicySttMap['2'],
  },
  {
    polSttCodeId: '3',
    polSttCodeName: PolicySttMap['3'],
  },
  {
    polSttCodeId: '4',
    polSttCodeName: PolicySttMap['4'],
  },
  {
    polSttCodeId: '5',
    polSttCodeName: PolicySttMap['5'],
  },
  {
    polSttCodeId: '6',
    polSttCodeName: PolicySttMap['6'],
  },
  {
    polSttCodeId: 'A',
    polSttCodeName: PolicySttMap.A,
  },
  {
    polSttCodeId: 'B',
    polSttCodeName: PolicySttMap.B,
  },
  {
    polSttCodeId: 'C',
    polSttCodeName: PolicySttMap.C,
  },
  {
    polSttCodeId: 'D',
    polSttCodeName: PolicySttMap.D,
  },
  {
    polSttCodeId: 'E',
    polSttCodeName: PolicySttMap.E,
  },
  {
    polSttCodeId: 'F',
    polSttCodeName: PolicySttMap.F,
  },
  {
    polSttCodeId: 'G',
    polSttCodeName: PolicySttMap.G,
  },
  {
    polSttCodeId: 'H',
    polSttCodeName: PolicySttMap.H,
  },
  {
    polSttCodeId: 'M',
    polSttCodeName: PolicySttMap.M,
  },
  {
    polSttCodeId: 'R',
    polSttCodeName: PolicySttMap.R,
  },
  {
    polSttCodeId: 'T',
    polSttCodeName: PolicySttMap.T,
  },
  {
    polSttCodeId: 'W,X',
    polSttCodeName: PolicySttMap.W,
  },
  {
    polSttCodeId: 'K',
    polSttCodeName: PolicySttMap.K,
  },
  {
    polSttCodeId: 'S',
    polSttCodeName: PolicySttMap.S,
  },
  {
    polSttCodeId: 'U',
    polSttCodeName: PolicySttMap.U,
  },
  {
    polSttCodeId: 'V',
    polSttCodeName: PolicySttMap.V,
  },
  {
    polSttCodeId: 'PCCC,PCCU,PCRC,PCRU,PECC,PECU,PERC,PERU,R1,R2,R3',
    polSttCodeName: PolicySttMap.PCCC,
  },
];

export const PoliciesFilterFormDefaultValues = {
  submittedDateFrom: '',
  submittedDateTo: '',
  appReceivedDateFrom: '',
  appReceivedDateTo: '',
  issuedDateFrom: '',
  issuedDateTo: '',
  appNumber: '',
  policyNumber: '',
  policyStatusCode: '',
  policySort: 'submitted_dt:DESC',
  serviceAgentInfo: '',
};

export const PoliciesFilterFormConstructor = {
  policyNumber: {
    label: 'Số hợp đồng',
    type: 'number',
    name: 'policyNumber',
  },
  appNumber: {
    label: 'Số HSYCBH',
    type: 'text',
    name: 'appNumber',
  },
  policyStatusCode: {
    label: 'Trạng thái hợp đồng',
    type: 'select-adv',
    name: 'policyStatusCode',
    isDiacriticSearch: true,
    config: polSttCodeConfig,
    items: polSttCodeItems,
  },
  submittedDateFrom: {
    label: 'Ngày nộp phí từ ngày',
    type: 'date',
    name: 'submittedDateFrom',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },
  submittedDateTo: {
    label: 'Đến ngày',
    type: 'date',
    name: 'submittedDateTo',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },
  appReceivedDateFrom: {
    label: 'Ngày nộp HSYCBH từ ngày',
    type: 'date',
    name: 'appReceivedDateFrom',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },
  appReceivedDateTo: {
    label: 'Đến ngày',
    type: 'date',
    name: 'appReceivedDateTo',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },
  issuedDateFrom: {
    label: 'Ngày phát hành HĐ',
    type: 'date',
    name: 'issuedDateFrom',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },
  issuedDateTo: {
    label: 'Đến ngày',
    type: 'date',
    name: 'issuedDateTo',
    defaultValue: null,
    unvalue: true,
    isClearable: true,
  },

  serviceAgentInfo: {
    label: 'Mã tư vấn - Tên tư vấn',
    type: 'text',
    name: 'serviceAgentInfo',
  },
};
